<template>
  <div>
    <!-- Navbar STart -->
    <header id="topnav" class="defaultscroll sticky" :class="{'bg-white': isWhiteNavbar === true}">
      <div>
        <div></div>
        <div class="container">
          <!-- Logo container-->
          <LoginHeader></LoginHeader>
          <div>
            <router-link class="logo" to="/" v-if="navLight !== true">
              <img src="@/assets/images/Golf/logo_golf.svg" height="60" alt="" />
            </router-link>
            <router-link class="logo" to="/" v-else>
              <img src="@/assets/images/Golf/logo_golf_w@2x.png" class="l-light" height="60" alt="" />
              <img src="@/assets/images/Golf/logo_golf.svg" class="l-dark" height="60" alt="" />
            </router-link>
          </div>

          <!--end login button-->
          <!-- End Logo container-->
          <div class="menu-extras">
            <div class="menu-item">
              <!-- Mobile menu toggle-->
              <a class="navbar-toggle" @click="toggleMenu()" :class="{open: isCondensed === true}">
                <div class="lines">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </a>
              <!-- End mobile menu toggle-->
            </div>
          </div>
          <div id="navigation">
            <!-- Navigation Menu-->
            <ul class="navigation-menu" :class="{'nav-light': navLight === true}">
              <!-- About Menu -->
              <li class="has-submenu">
                <a href="javascript:void(0)" @click="onMenuClick">ABOUT</a>
                <span class="menu-arrow"></span>
                <ul class="submenu">
                  <li>
                    <router-link to="/p/introduce" class="side-nav-link-ref">클럽소개</router-link>
                  </li>
                  <li>
                    <router-link to="/p/Awards" class="side-nav-link-ref">어워즈</router-link>
                  </li>
                  <li>
                    <router-link to="/p/Tournament" class="side-nav-link-ref">토너먼트</router-link>
                  </li>
                  <li>
                    <router-link to="/p/Photoview" class="side-nav-link-ref">포토뷰</router-link>
                  </li>
                  <li>
                    <router-link to="/p/Notice" class="side-nav-link-ref">공지사항</router-link>
                  </li>
                  <li>
                    <router-link to="/p/Newsroom" class="side-nav-link-ref">뉴스룸</router-link>
                  </li>
                </ul>
              </li>
              <!-- Operation Guide Menu -->
              <li class="has-submenu">
                <a href="javascript:void(0)" @click="onMenuClick">OPERATION GUIDE</a>
                <span class="menu-arrow"></span>
                <ul class="submenu">
                  <li>
                    <router-link to="/p/Infoguidance" class="side-nav-link-ref">이용안내</router-link>
                  </li>
                  <li>
                    <router-link to="/p/Reservguidance" class="side-nav-link-ref">예약안내</router-link>
                  </li>
                  <li>
                    <router-link to="/p/Feeguidance" class="side-nav-link-ref">요금안내</router-link>
                  </li>
                </ul>
              </li>
              <!-- Golf Course Menu -->
              <li class="has-submenu">
                <a href="javascript:void(0)" @click="onMenuClick">GOLF COURSE</a>
                <span class="menu-arrow"></span>
                <ul class="submenu">
                  <li>
                    <router-link to="/p/Course" class="side-nav-link-ref">전체 코스</router-link>
                  </li>
                  <li>
                    <router-link to="/p/Course" class="side-nav-link-ref">EAST 코스</router-link>
                  </li>
                  <li>
                    <router-link to="/p/Course" class="side-nav-link-ref">WEST 코스</router-link>
                  </li>
                  <li>
                    <router-link to="/p/Course" class="side-nav-link-ref">NORTH 코스</router-link>
                  </li>
                </ul>
              </li>
              <!-- Facilities Menu -->
              <li class="has-submenu">
                <a href="javascript:void(0)" @click="onMenuClick">FACILITIES</a>
                <span class="menu-arrow"></span>
                <ul class="submenu">
                  <li>
                    <router-link to="/p/Sauna" class="side-nav-link-ref">사우나·락카</router-link>
                  </li>
                  <li>
                    <router-link to="/p/Proshop" class="side-nav-link-ref">프로샵</router-link>
                  </li>
                  <li>
                    <router-link to="/p/Golfpractice" class="side-nav-link-ref">어프로치 존</router-link>
                  </li>
                  <li>
                    <router-link to="/p/Banquethall" class="side-nav-link-ref">연회장</router-link>
                  </li>
                </ul>
              </li>
              <!-- Dining Menu -->
              <li class="has-submenu">
                <a href="javascript:void(0)" @click="onMenuClick">DINING</a>
                <span class="menu-arrow"></span>
                <ul class="submenu">
                  <li>
                    <router-link to="/p/Restaurant" class="side-nav-link-ref">레스토랑</router-link>
                  </li>
                  <li>
                    <router-link to="/p/GrBBQ" class="side-nav-link-ref">그린사이즈 BBQ</router-link>
                  </li>
                  <li>
                    <router-link to="/p/Starthouse" class="side-nav-link-ref">스타트하우스</router-link>
                  </li>
                </ul>
              </li>
              <!-- Reservation Menu -->
              <li class="has-submenu">
                <a href="javascript:void(0)" @click="onMenuClick">RESERVATION</a>
                <span class="menu-arrow"></span>
                <ul class="submenu">
                  <li>
                    <router-link to="/p/Preregistration" class="side-nav-link-ref">사전접수</router-link>
                  </li>
                  <li>
                    <router-link to="/p/Waitingreception" class="side-nav-link-ref">잔여접수</router-link>
                  </li>
                  <li>
                    <router-link to="/p/Realtimebooking" class="side-nav-link-ref">실시간예약</router-link>
                  </li>
                </ul>
              </li>
              <!-- Specialoffer Menu -->
              <li>
                <router-link to="/p/Specialoffers" class="side-nav-link-ref">SPECIAL OFFERS</router-link>
              </li>
            </ul>
            <!--end navigation menu-->

            <!--end login button-->
          </div>
          <!--end navigation-->
        </div>
        <!--end container-->
      </div>
    </header>
    <!--end header-->
    <!-- Navbar End -->
  </div>
</template>

<script>
/**
 * Navbar component
 */
import LoginHeader from '@/components/LoginHeader';

export default {
  data() {
    return {
      isCondensed: false,
    };
  },
  components: {LoginHeader},
  props: {
    isWhiteNavbar: {
      type: Boolean,
    },
    navLight: {
      type: Boolean,
    },
    isIcons: {
      type: Boolean,
    },
  },
  mounted() {
    window.onscroll = function () {
      onwindowScroll();
    };

    function onwindowScroll() {
      if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
        document.getElementById('topnav').classList.add('nav-sticky');
      } else {
        document.getElementById('topnav').classList.remove('nav-sticky');
      }

      if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
        document.getElementById('back-to-top').style.display = 'inline';
      } else {
        document.getElementById('back-to-top').style.display = 'none';
      }
    }

    var links = document.getElementsByClassName('side-nav-link-ref');
    var matchingMenuItem = null;
    for (var i = 0; i < links.length; i++) {
      if (window.location.pathname === links[i].pathname) {
        matchingMenuItem = links[i];
        break;
      }
    }

    if (matchingMenuItem) {
      matchingMenuItem.classList.add('active');
      var parent = matchingMenuItem.parentElement;

      /**
       * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
       * We should come up with non hard coded approach
       */
      if (parent) {
        parent.classList.add('active');
        const parent2 = parent.parentElement;
        if (parent2) {
          parent2.classList.add('active');
          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.add('active');
            const parent4 = parent3.parentElement;
            if (parent4) {
              const parent5 = parent4.parentElement;
              parent5.classList.add('active');
            }
          }
        }
      }
    }
  },
  methods: {
    toggleMenu() {
      this.isCondensed = !this.isCondensed;
      if (this.isCondensed) {
        document.getElementById('navigation').style.display = 'block';
      } else document.getElementById('navigation').style.display = 'none';
    },

    onMenuClick(event) {
      event.preventDefault();
      const nextEl = event.target.nextSibling.nextSibling;

      if (nextEl && !nextEl.classList.contains('open')) {
        const parentEl = event.target.parentNode;
        if (parentEl) {
          parentEl.classList.remove('open');
        }
        nextEl.classList.add('open');
      } else if (nextEl) {
        nextEl.classList.remove('open');
      }
      return false;
    },
  },
};
</script>

<style scoped lang="scss">
//.divStyle {
//  background: white;
//  height: 80px;
//
//  .b-nav {
//    height: 80px;
//  }
//}
</style>
